export function isValidDate(value) {
  const pattern = /^[0-9]{4}-[0-1][0-9]-[0-3][0-9]$/; // YYYY-MM-DD
  return !value || pattern.test(value);
}

export function isValidDateTime(value) {
  const pattern = /^[0-9]{4}-[0-1][0-9]-[0-3][0-9]T[0-2][0-9]:[0-5][0-9]$/;
  return !value || pattern.test(value.slice(0, 16));
}

export function isValidUrl(url) {
  const regex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
  return regex.test(url);
}

export function isValidDomain(domain) {
  const domainPattern = /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/;
  return domainPattern.test(domain);
}

export function requiredIfBannerEnabled(value, vm) {
  return !vm.enabled || !!value;

}




// WEBPACK FOOTER //
// ./src/services/validatorService.js